import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgZapier = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1618_5819)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M35.7 0H6.3C2.82061 0 0 2.82061 0 6.3V35.7C0 39.1794 2.82061 42 6.3 42H35.7C39.1794 42 42 39.1794 42 35.7V6.3C42 2.82061 39.1794 0 35.7 0Z",
			fill: "#FF4F00"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M35.7001 27.2998H6.30005V35.6998H35.7001V27.2998Z",
			fill: "#FFFDF9"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1618_5819",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 42,
			height: 42,
			fill: "white"
		})
	}) })]
});
export default SvgZapier;
